// Puzzle bookkeeping (docs/02-Game-Design/Puzzle Mode.md): a found word fills
// its own blank, identified by the word; two solution words may share a
// length. The game only ever sees lengths and filled words; the server, which
// holds the solutions, computes these.

export interface Blank {
  length: number;
  /** The word once found, otherwise null. */
  word: string | null;
}

/** The blank a newly accepted word fills, or -1. Solution words are unique in a level. */
export function blankIndexFor(solutions: readonly string[], word: string): number {
  return solutions.indexOf(word);
}

export function blanksFor(solutions: readonly string[], foundWords: readonly string[]): Blank[] {
  const found = new Set(foundWords);
  return solutions.map((word) => ({ length: Array.from(word).length, word: found.has(word) ? word : null }));
}

/** Solved: every solution word is a constellation at the same time. */
export function puzzleComplete(solutions: readonly string[], foundWords: readonly string[]): boolean {
  const found = new Set(foundWords);
  return solutions.every((w) => found.has(w));
}

/** The text a phrase or quotation puzzle shows, with its {n} placeholders; null for a category. */
export function promptText(puzzle: { type: 'category' } | { type: 'phrase'; phrase: string } | { type: 'quotation'; quotation: string }): string | null {
  if (puzzle.type === 'phrase') return puzzle.phrase;
  if (puzzle.type === 'quotation') return puzzle.quotation;
  return null;
}
